import type { TFunction } from "i18next";

/**
 * Texto de la columna "Organizaciones" del listado de /admin/estudios.
 *
 * `organizations` vacío por sí solo no distingue "nadie puede ver este
 * insight" de "no hay organizaciones, pero sí hay usuarios puntuales
 * concedidos" -ambos casos llegaban antes con el mismo arreglo vacío, y la
 * pantalla mostraba "Nadie podría ver este insight" para los dos, lo cual
 * era engañoso en el segundo-. `hasUserAccess` (studySummary) es lo que
 * separa ambos casos.
 */
export function formatAccessSummary(
  organizations: string[],
  hasUserAccess: boolean,
  t: TFunction,
): string {
  if (organizations.length === 0) {
    return hasUserAccess ? t("studyForm.accessSpecificUsers") : t("studyForm.accessEmpty");
  }

  const primera = organizations[0] ?? "";
  const restantes = organizations.length - 1;
  const base =
    restantes > 0
      ? `${primera} ${t("studyForm.accessMoreOrganizations", { count: restantes })}`
      : primera;

  return hasUserAccess ? `${base} ${t("studyForm.accessPlusSpecificUsers")}` : base;
}
